@if (datos() !== null && datos() !== undefined) {
  <div class="px-6 py-4 space-y-6">
    <div class="grid grid-cols-2 gap-1">
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-1">Usuario</label>
        <p class="text-slate-900 font-medium">{{ datos()!.usuario_nombre_completo }}</p>
      </div>
      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-1">Hora de apertura</label>
        <p class="text-slate-900 font-medium">{{ datos()!.hora_apertura | date: 'short' }}</p>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div class="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-slate-600">Ventas realizadas</p>
            <p class="text-xl font-bold text-emerald-700">
              {{ datos()!.total_ventas_brutas ?? datos()!.monto_cierre_sistema | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>
          <i class="bi bi-info-circle text-emerald-500 text-2xl" appTooltip="Suma de movimientos de venta realizados durante el turno de caja"></i>
        </div>
      </div>
      <div class="bg-accent-50 border border-accent-200 rounded-xl p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-slate-600">Monto de apertura</p>
            <p class="text-xl font-bold text-accent-700">{{ datos()!.monto_apertura | currency: 'PEN' : 'S/. ' }}</p>
          </div>
          <i class="bi bi-info-circle text-accent-500 text-2xl" appTooltip="Dinero en caja aperturado"></i>
        </div>
      </div>
      <div class="bg-purple-50 border border-purple-200 rounded-xl p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-slate-600">Efectivo esperado en caja</p>
            <p class="text-xl font-bold text-purple-700">
              {{ datos()!.efectivo_esperado ?? datos()!.monto_cierre_efectivo | currency: 'PEN' : 'S/. ' }}
            </p>
          </div>
          <i class="bi bi-info-circle text-purple-500 text-2xl" appTooltip="Monto en efectivo que físicamente debería existir en caja"></i>
        </div>
      </div>
      <div class="bg-amber-50 border border-amber-200 rounded-xl p-4">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-sm text-slate-600">Egresos del turno</p>
            <p class="text-xl font-bold text-amber-700">{{ datos()!.total_egresos ?? 0 | currency: 'PEN' : 'S/. ' }}</p>
          </div>
          <i class="bi bi-info-circle text-amber-500 text-2xl" appTooltip="Total de egresos registrados durante el turno"></i>
        </div>
      </div>
    </div>

    <div class="space-y-4 pt-4 border-t border-slate-200">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-semibold text-slate-700 mb-2">Monto de cierre</label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400">S/.</span>
            <input
              type="number"
              [formField]="$any(form.monto)"
              placeholder="0.00"
              step="0.01"
              class="w-full pl-10 pr-4 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400 text-sm transition-all duration-150"
              [class.border-slate-200]="!form.monto().touched() || !form.monto().invalid()"
              [class.hover:border-slate-300]="!form.monto().touched() || !form.monto().invalid()"
              [class.border-red-400]="form.monto().touched() && form.monto().invalid()"
              [class.focus:ring-red-500]="form.monto().touched() && form.monto().invalid()"
              [class.focus:border-red-500]="form.monto().touched() && form.monto().invalid()"
            />
          </div>
          @if (form.monto().touched() && form.monto().invalid()) {
            <small class="text-red-600 text-xs mt-1 block">{{ form.monto().errors() | formErrorMessage }}</small>
          }
        </div>
        <div
          class="rounded-xl p-4 border"
          [class.bg-emerald-50]="diferencia() >= 0"
          [class.bg-red-50]="diferencia() < 0"
          [class.bg-slate-50]="!diferencia()"
          [class.border-emerald-200]="diferencia() >= 0"
          [class.border-red-200]="diferencia() < 0"
        >
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-slate-600">Diferencia</p>
              <p class="text-xl font-bold" [class.text-emerald-700]="diferencia() >= 0" [class.text-red-600]="diferencia() < 0">
                {{ diferencia() | currency: 'PEN' : 'S/. ' }}
              </p>
            </div>
            <i class="bi bi-info-circle text-2xl" [class.text-emerald-500]="diferencia() >= 0" [class.text-red-500]="diferencia() < 0" appTooltip="Diferencia entre el monto esperado y el monto reportado"></i>
          </div>
        </div>
      </div>

      <div>
        <label class="block text-sm font-semibold text-slate-700 mb-2">Motivo cierre reportado</label>
        <textarea
          type="text"
          [formField]="$any(form.descripcion)"
          placeholder="Ingrese el motivo"
          class="w-full px-4 py-2 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 placeholder:text-slate-400 text-sm transition-all duration-150 resize-none"
          [class.border-slate-200]="!form.descripcion().touched() || !form.descripcion().invalid()"
          [class.hover:border-slate-300]="!form.descripcion().touched() || !form.descripcion().invalid()"
          [class.border-red-400]="form.descripcion().touched() && form.descripcion().invalid()"
          [class.focus:ring-red-500]="form.descripcion().touched() && form.descripcion().invalid()"
          [class.focus:border-red-500]="form.descripcion().touched() && form.descripcion().invalid()"
        ></textarea>
        @if (form.descripcion().touched() && form.descripcion().invalid()) {
          <small class="text-red-600 text-xs mt-1 block">{{ form.descripcion().errors() | formErrorMessage }}</small>
        }
      </div>
    </div>

    <div class="pt-4 border-t border-slate-200">
      <h3 class="text-sm font-semibold text-slate-900 mb-4">Totales por tipo de pago:</h3>
      <h4 class="text-sm font-medium text-slate-700 mb-3">Movimientos</h4>

      @if (datos()!.movimientos && datos()!.movimientos.length > 0) {
        <div class="overflow-x-auto max-h-64">
          <table class="w-full text-sm">
            <thead class="bg-slate-100 sticky top-0">
              <tr class="border-b border-slate-200 bg-slate-50">
                <th class="text-left px-4 py-3 font-semibold text-slate-700">Fecha</th>
                <th class="text-left px-4 py-3 font-semibold text-slate-700">Tipo</th>
                <th class="text-right px-4 py-3 font-semibold text-slate-700">Monto</th>
                <th class="text-left px-4 py-3 font-semibold text-slate-700">Tipo de Pago</th>
              </tr>
            </thead>
            <tbody>
              @for (movimiento of datos()!.movimientos; track $index) {
                <tr class="border-b border-slate-100 hover:bg-slate-50 transition-colors text-center">
                  <td class="px-4 py-3 text-slate-900">{{ movimiento.created_at | date: 'short' }}</td>
                  <td class="px-4 py-3 text-slate-900">{{ movimiento.tipo }}</td>
                  <td class="px-4 py-3 text-right text-slate-900 font-medium">{{ movimiento.monto | currency: 'PEN' : 'S/. ' }}</td>
                  <td class="px-4 py-3 text-slate-900">{{ movimiento.tipo_pago_nombre }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="text-center py-8 text-slate-500">
          <p class="text-sm">No hay movimientos registrados</p>
        </div>
      }
    </div>
  </div>

  <div class="border-t border-slate-200 px-6 py-4 flex gap-4 justify-center">
    <button
      (click)="onCancelar()"
      class="px-6 py-2 border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 font-medium transition-colors"
    >
      Cancelar
    </button>
    <button
      (click)="onAceptar()"
      class="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-500 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Cerrar caja
    </button>
  </div>
} @else {
  <div class="card flex justify-center">
    <app-progress-spinner strokeWidth="8" size="48" />
  </div>
}
